import {Component, input} from '@angular/core';
import {BadgeComponent} from '../../../../../../../shared/components/badge/badge.component';
import {IconsComponent} from '../../../../../../../shared/components/icons/icons.component';
import {TooltipComponent} from '../../../../../../../shared/components/tooltip/tooltip.component';
import {CurrencyPipe} from '@angular/common';

@Component({
  selector: 'app-results-table-row-availability-badge-transfer',
  imports: [
    BadgeComponent,
    IconsComponent,
    TooltipComponent,
    CurrencyPipe
  ],
  templateUrl: './results-table-row-availability-badge-transfer.component.html',
  styleUrl: './results-table-row-availability-badge-transfer.component.css'
})
export class ResultsTableRowAvailabilityBadgeTransferComponent {
  data = input.required<any>();
  price = input.required<(cost: number) => number>();
}
